"use client";

import { FC, useEffect } from "react";
import { useHintCardStore } from "@/src/stores/useHintCardStore";
import { HintCardClientWrapperProps } from "../lib/type";
import { HintCard } from "./HintCard";
import { isNumber } from "lodash";

export const HintCardClientWrapper: FC<HintCardClientWrapperProps> = ({
  cardTitle = "Помічник оформлення полісу",
  defaultHints,
  defaultHint = 1,
}) => {
  const {
    hints,
    variant,
    setNextStep,
    setPrevStep,
    setDefaultHints,
    activeStep,
    defaultHints: storedDefaultHints,
    setHintsList,
  } = useHintCardStore((state) => state);

  useEffect(() => {
    if (defaultHints?.length) {
      setHintsList([]);
      setDefaultHints(defaultHints, defaultHint - 1);
    }
  }, [defaultHints, defaultHint]);

  const activeHint = hints[activeStep] || storedDefaultHints[activeStep];
  const maxSteps = hints.length || storedDefaultHints.length;

  return (
    <HintCard
      cardTitle={cardTitle}
      contentTitle={activeHint?.contentTitle || ""}
      contentDescription={activeHint?.contentDescription || ""}
      variant={variant}
      maxSteps={maxSteps}
      onNextStep={setNextStep}
      onPrevStep={setPrevStep}
      activeStep={activeHint ? activeStep : undefined}
      // hintCardDetailsButtonText={activeHint?.hintCardDetailsButtonText}
      hintCardDetailsButton={activeHint?.hintCardDetailsButton}
      hintDetailsActions={activeHint?.hintDetailsActions}
      hintDetailsDescription={activeHint?.hintDetailsDescription}
      hintDetailsTitle={activeHint?.hintDetailsTitle}
      onHintCardDetailsButtonPressed={
        activeHint?.onHintCardDetailsButtonPressed
      }
    />
  );
};
